module.exports = __webpack_public_path__ + "static/demon_armor-8dac842e747d87d74ad6079517279d85.jpeg";